/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { environment } from "src/environments/environment";
export const addServerUrl = (apiURL: string): string => {
  return environment.server + apiURL;
};
export const API_PATH = {
  // TODO add environment.server by default with apis: addUrlFunction(Object) instead of adding to every url
  apis: {
    // registerPreSignUpOtp: environment.server + '/sendpresignupotp',
    orderByID: environment.server + "/orders",
    product: environment.server + "/scanValuTrace",
    stories: environment.server + "/stories",
    server: environment.server,
    signup: environment.server + "/user/sendpresignupotp",
    signin: environment.server + "/auth/signin",
    verifyOTP: environment.server + "/user/sendpresignupotp",
    sendOTP: environment.server + "/user/otpuserpassword",
    changePassword: environment.server + "/users/password",
    saveReview: environment.server + "/reviews/save",
    sendLike: environment.server + "/reviews/userlikedislike",
    fetchReview: environment.server + "/reviews",
    userReviews: environment.server + "/users/reviews",
    reviewLikeDislike: environment.server + "/reviews/userlikedislike",
    photoUpload: environment.server + "/fileupload",
    favourite: environment.server + "/users/favourites",
    userProfileUpdate: environment.server + "/users",
    userProfileData: environment.server + "/users/me",
    getEvidences: environment.server + "/companyEvidences",
    getStories: environment.server + "/companyStories",
    scanQr: environment.server + "/scanDataPublic",
    locationBusinessUnits: environment.server + "/getGeoLocationBusinessUnits",
    businessUnitSlots: environment.server + "/appointments",
    appointment: environment.server + "/appointment",
    callBack: environment.server + "/callBack",
    deleteAppointment: environment.server + "/deleteAppointmentsBySlotMaster",
    signingoogle: environment.server + "/auth/google",
    registerStore: environment.server + "/leads",
    businessUnits: environment.server + "/branches",
    businessUsers: environment.server + "/businessUsers",
    businessUsersGroupAction:
      environment.server + "/auth/companyUserMassActions",
    businessUnitDetails: environment.server + "/brancheusers/",
    companyInchargeUsers: environment.server + "/companyInchargeUsers/",
    getBusinessUnitsByCompany:
      environment.server + "/getBusinessUnitsByCompany",
    userGroups: environment.server + "/auth/userGroups",
    adduser: environment.server + "/auth/adduser",
    updateuser: environment.server + "/auth/updateuser",
    getvideocalldetails: environment.server + "/getVideoCallData",
    getAppointmentSettings: environment.server + "/getappointmentunitsettings",
    massUpdateAppointment: environment.server + "/massUpdateAppointments",
    inventoriesByInventoryGroup:
      environment.server + "/inventoriesByInventoryGroup",
    updateAppointmentProducts:
      environment.server + "/updateAppointmentProducts",
    updateSettings: environment.server + "/updateSettings",
    getAppointmentsOrders: environment.server + "/getAppointmentsOrders",
    getContactOrders: environment.server + "/getContactOrders",
    createAppointmentOrder: environment.server + "/createAppointmentOrder",
    configurationURL: environment.server + "/configurations",
    clickToCallKeyGen: environment.server + "/createC2CKey",
    addParticipants: environment.server + "/addAppointmentParticipants",
    orderReport: environment.server + "/orderReport",
    cancelOrder: environment.server + "/cancelOrder",
    logActivity: environment.server + "/logActivity",
    updateSellerStatus: environment.server + "/updateOrderStatus",
    sendOtpEmail: environment.server + "/validatetParticipants",
    getAppointmentGroupData: environment.server + "/appointmentgroup",
    updateAppointmentGroupData: environment.server + "/appointmentgroup/",
    loginWithOTP: environment.server + "/user/signinwithotp",
    confirmWithOtp: environment.server + "/user/confirmwithotp",
    consumerRegister: environment.server + "/user/addMiniUser",
    consumer: environment.server + "/consumer",
    getCscData: environment.server + "/getCscData",
    stripePayment: environment.server + "/stripeSession",
    stripeAccount: environment.server + "/stripeAccount",
    checkStripeStatus: environment.server + "/checkAccount",
    checkPaymentStatus: environment.server + "/checkPayment",
    mediaTemplates: environment.server + "/mediatemplates",
    getPaymentOrderId: addServerUrl("/getRazorpayOrderId"),
    updateRazorpayPayment: addServerUrl("/updateRazorpayPayment"),
    codShipment: addServerUrl("/codShipment"),
    updateFailedPayment: addServerUrl("/updateFailedPayment"),
    startProductSync: addServerUrl("/shopifysync"),
    createShopifyWebhooks: addServerUrl("/createShopifyWebhook"),
    resetPayment: addServerUrl("/resetPayment"),
    checkProductAvailability: addServerUrl("/checkProductAvailability"),
    createPaypalOrder: addServerUrl("/paypal/createOrder"),
    capturePaypalOrder: addServerUrl("/paypal/captureOrder"),
    updateMultipleOrdersProducts:
      environment.server + "/updateMultipleOrdersProducts",
    updateUserCart: environment.server + "/updateUserCart",
    updateUserWishlist: addServerUrl("/updateUserWishlist"),
    companySettings: "/companySettingsData",
    getDeliverySlots: "/deliveryslots",
  },
  fileUploadAPI: {
    fileuploadroute: environment.server + "/fileupload",
    fileuploadBase64route: environment.server + "/saveImage",
  },
  paymentAPI: {
    companyPaymentModes: environment.server + "/companypaymentmodes",
    companyPaymentTerms: environment.server + "/companypaymentterms",
  },
  quotationAPI: {
    createQuotation: environment.server + "/customOrder",
    createQuoteOrder: environment.server + "/orderBySeller",
    updateQuoteStatus: environment.server + "/customOrderUpdate",
  },
};

export const APIKEY = {
  googleMapsAPIKEY: "AIzaSyCv2BVw4A3-q2LBEafJOfLQnBxEWau5tY4",
};
export const currencyCode = {
  code: "inr",
};
export const currency_symbols = {
  USD: "$", // US Dollar
  AUD: "$", // AU Dollar
  EUR: "€", // Euro
  CRC: "₡", // Costa Rican Colón
  GBP: "£", // British Pound Sterling
  ILS: "₪", // Israeli New Sheqel
  INR: "₹", // Indian Rupee
  JPY: "¥", // Japanese Yen
  KRW: "₩", // South Korean Won
  NGN: "₦", // Nigerian Naira
  PHP: "₱", // Philippine Peso
  PLN: "zł", // Polish Zloty
  PYG: "₲", // Paraguayan Guarani
  THB: "฿", // Thai Baht
  UAH: "₴", // Ukrainian Hryvnia
  VND: "₫", // Vietnamese Dong
  LKR: "Rs",
  SGD: "$",
  PKR: "Rs",
  NZD: "$",
  MYR: "RM",
  IDR: "Rp",
  HKD: "HK$",
  CNY: "¥",
  BDT: "৳",
  PEN: "S/.",
  MXN: "$",
  COP: "$",
  CLP: "$",
  CAD: "$",
  BRL: "R$",
  ZAR: "R",
  MAD: ".د.م",
  KES: "Ksh",
  AED: "د.إ",
  TRY: "₺",
  SEK: "kr",
  RON: "lei",
  RUB: "₽",
  NOK: "kr",
  HUF: "ft",
  GEL: "₾",
  HRK: "kn",
  DKK: "kr",
  CZK: "Kč",
  CHF: "CHF",
  BGN: "лв",
};
export const icons = {
  businessUserIcon: {
    defaultImg: "assets/company/icons/person.png",
  },

  businessUnitIcon: {
    defaultImg: "assets/company/icons/defaultUnitImage.svg",
    locationIcon: "assets/icons/location.svg",
    itemMaster: "assets/images/itemmaster.svg",
  },

  registerStoreIcons: {
    success: "assets/icons/success.svg",
  },
  jdxIcon: {
    jdxLogo: "assets/icons/JDX-Logo.png",
    jdxDarkLogo: "assets/icons/JDX-Logo.png",
    jdxDarkTotalLogo: "assets/icons/JDX-Logo.png",
  },
  highlineIcon: {
    logo: "assets/icons/highline-united-logo.png",
    landingPage: "assets/images/highline-landing-page1.jpg",
  },
  srsmIcon: {
    srsmIcon: "assets/icons/SRlogo.png",
  },
  happybabyIcon: {
    happybabyIcon: "assets/icons/Happybabystore_logo.jpg",
  },
  whiteShopIcon: {
    icon: "assets/icons/Shopconnect_logo_new.png",
    icon_white: "assets/icons/Shopconnect_logo_new_white.svg",
    landingPage: "assets/icons/whiteShopHome.png",
    landingPage1: "assets/images/whiteshopLanding.jpg",
    retailerHomePage: "assets/images/retailer-home-page.jpeg",
    visibilityOff: "assets/icons/blackEyeOff.svg",
    visibilityOn: "assets/icons/blackEye.svg",
    darkLogo: "assets/images/Whiteshop-Dark-version.png",
    unBookedUserImg: "assets/images/user.svg",
    eye: "assets/icons/blueEye.svg",
    eyeSlash: "assets/icons/blueEyeOff.svg",
    listIcon: "assets/icons/listicon.svg",
    thumbnailIcon: "assets/icons/thumbnailIcon.svg",
    person: [
      "assets/images/person1.jpg",
      "assets/images/person2.jpg",
      "assets/images/person3.jpg",
    ],
    shoes: [
      "assets/images/Shoes.jpg",
      "/assets/images/shoes1.jpg",
      "/assets/images/shoes2.jpg",
      "/assets/images/shoes3.jpg",
    ],
    cosmetics: [
      "assets/images/Beauty.jpg",
      "/assets/images/cosmetics1.jpg",
      "/assets/images/cosmetics2.jpg",
      "/assets/images/cosmetics3.jpg",
    ],
    furniture: [
      "assets/images/Furniture.jpg",
      "/assets/images/furniture1.jpg",
      "/assets/images/furniture2.jpg",
      "/assets/images/furniture3.jpg",
    ],
    textile: [
      "assets/images/Textile.jpg",
      "assets/images/textile1.jpg",
      "assets/images/textile2.jpg",
      "assets/images/textile3.jpg",
    ],
    jewellery: [
      "assets/images/Jewellery.jpg",
      "assets/images/jewellery1.jpg",
      "assets/images/jewellery2.jpg",
      "assets/images/jewellery3.jpg",
    ],
    invite: "assets/icons/inviteIcon.svg",
    curatedProductsIcon: "assets/icons/curatedProductsIcon.svg",
  },
  footerIcons: {
    fb: "assets/icons/newFacebookLogo.svg",
    youTube: "assets/icons/newYoutubeLogo.svg",
    linkedIn: "assets/icons/newLinkedInLogo.svg",
    twitter: "assets/icons/newTwitterLogo.svg",
    instagram: "assets/icons/newInstagramLogo.svg",
    fbFooterColored: "assets/icons/facebookFooterLogoColored.svg",
    youTubeFooterColored: "assets/icons/youtubeFooterLogoColored.svg",
    linkedInFooterColored: "assets/icons/linkedInFooterLogoColored.svg",
    twitterFooterColored: "assets/icons/twitterFooterLogoColored.svg",
    instagramFooterColored: "assets/icons/instagramFooterLogoColored.svg",
  },
  footerIcons3D: {
    fb: "assets/icons/facebook-3d.svg",
    youTube: "assets/icons/youtube-3d.svg",
    linkedIn: "assets/icons/newLinkedInLogo.svg",
    twitter: "assets/icons/twitter-3d.svg",
    instagram: "assets/icons/instagram-3d.svg",
    fbFooterColored: "assets/icons/facebookFooterLogoColored.svg",
    youTubeFooterColored: "assets/icons/youtubeFooterLogoColored.svg",
    linkedInFooterColored: "assets/icons/linkedInFooterLogoColored.svg",
    twitterFooterColored: "assets/icons/twitterFooterLogoColored.svg",
    instagramFooterColored: "assets/icons/instagramFooterLogoColored.svg",
  },
  liveshopIcon: {
    book: "assets/icons/book.svg",
    blackCart: "assets/icons/blackCart.svg",
    blueCart: "assets/icons/blueCart.svg",
    blackFavourite: "assets/icons/blackFavourite.svg",
    blueFavourite: "assets/icons/blueFavourite.svg",
    addressSelection: "assets/icons/addressSelection.svg",
    edit: "assets/icons/edit.svg",
    attach: "assets/offer/paper-clip-16.png",
    close: "assets/offer/baseline_close_white_18dp.png",
  },
  interactiveImage: {
    view: "assets/icons/blackEye.svg",
    review: "assets/icons/chatBlack.svg",
    addToCart: "assets/icons/blackCart.svg",
    removeFromCart: "assets/icons/whiteCart.svg",
  },
  paymentGateway: {
    stripe: "assets/icons/stripe.svg",
    razorpay: "assets/icons/razorPay.svg",
  },
};

export const Regex = {
  regularExpression: {
    // regex for GSTIN number
    exp_GSTIN:
      "/^[0-9]{2,2}[a-zA-Z]{5,5}[0-9]{4,4}[a-zA-Z]{1,1}[1-9a-zA-Z]{1,1}[a-zA-Z]{1,1}[0-9a-zA-Z]{1,1}$/",
    // regex for mobile and email id
    exp_mail: /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[_a-zA-Z0-9]([\w\-]+)+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/,
    //  /^(([_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})))+$/,
    //         /^(?:\d{10,11}|([_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})))$/
    // regex for OTP
    exp_OTP: "/^[0-9]{6}$/",
    // regex for phone '/^[0-9]{10}$/'
    exp_phone: "/^[0-9]{10,11}$/",
    // regex for PAN
    exp_PAN: "/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/",
    // regex for IFSC code
    exp_IFSC: "/^[A-Za-z]{4}0[A-Za-z0-9]{6}$/",
    // regex for bankAccountNumber
    exp_accountNumber: "/^[0-9]{9,18}$/",
    // regex for pincode
    exp_pincode: "/^[0-9]{5,6}$/",
    // regex for aadharNumber
    exp_aadhar: "/^[0-9]{12}$/",
    // regex for ESI
    exp_esi: "/^[0-9]{17}$/",
    // regex for vehicle
    exp_vehicleNumber: "/^[A-Z0-9]{7,10}$/",
    // jdx account number (temporary)
    exp_jdxAccountNumber: "/^[a-zA-Z0-9]{0,20}$/",
  },
};

export const currency = {
  currency:
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("team1")
      ? "$"
      : "₹",
};
export const retryExpiry = 25; //minutes
export const storeText = {
  text: "Store",
};
export const isFilter = {
  flag: true,
};
export const isProducts = {
  flag: true,
};
export const isCurrencyDollar = {
  flag:
    window.location.hostname.startsWith("jdx") ||
    window.location.href.includes("patrician") ||
    window.location.hostname.includes("highlineunitedmarketplace") ||
    window.location.href.includes("intercept") ||
    window.location.hostname.includes("demo") ||
    window.location.href.includes("localhost")
      ? true
      : false,
};
export const isJDXHomePage = {
  flag:
    (window.location.hostname.startsWith("jdx") ||
      window.location.href.includes("patrician") ||
      window.location.href.includes("titan")) &&
    !window.location.hostname.includes("salesdemo")
      ? true
      : false,
  isHighLine: window.location.hostname.includes("highlineunitedmarketplace")
    ? true
    : false,
};
export const isOfferProducts = {
  data: {},
};
export const isSRSMFlag = {
  flag:
    window.location.href.includes("srsm") ||
    window.location.href.includes("srshopping")
      ? true
      : false,
};
export const isHappyBabyFlag = {
  flag: window.location.href.includes("happybaby") ? true : false,
};
export const isPanchwatiFlag = {
  flag: window.location.href.includes("panchwati") ? true : false,
};
export const isTitanFlag = {
  flag: window.location.href.includes("titanfootwear") ? true : false,
};
export const isPatricianFlag = {
  flag: window.location.href.includes("patrician") ? true : false,
};
export const isClickToCallFlag = {
  flag:
    window.location.href.includes("call") &&
    !window.location.href.includes("callback")
      ? true
      : false,
};
export const isClickToConnect = {
  flag:
    window.location.href.includes("clicktocall") &&
    window.location.href.includes("division")
      ? true
      : false,
};

export const c2cEnv = {
  production: "-prod-logov2",
  staging: "-staging",
  qa: "",
  local: "-local",
};

export const dateFormats = {
  "United States": {
    locale: "en-US",
    shortDate: "MM-dd-yyyy",
    shortDateSlash: "MM/dd/yyyy",
    short: "MM-dd-yy",
    shortSlash: "MM/dd/yy",
    longDate: "MMMM dd yyyy",
    mediumDate: "MMM dd yy",
    longYearDate: "MMM dd yyyy",
    shorter: "MM/dd",
    medium: "MMM dd",
    fullDate: "MM-dd-yyyy h:mm a",
    dateTime: "EEE MMM-dd-yyyy, h:mm:ss a",
    dateTimeShortFormat: "EEE dd-MMM-yyyy",
    dateTimeShort: "MM-dd-yyyy, h:mm a",
  },
  India: {
    locale: "en-GB",
    shortDate: "dd-MM-yyyy",
    shortDateSlash: "dd/MM/yyyy",
    short: "dd-MM-yy",
    shortSlash: "dd/MM/yy",
    longDate: "dd MMMM yyyy",
    mediumDate: "dd MMM yy",
    longYearDate: "dd MMM yyyy",
    shorter: "dd/MM",
    medium: "dd MMM",
    fullDate: "dd-MM-yyyy h:mm a",
    dateTime: "EEE dd-MMM-yyyy, h:mm:ss a",
    dateTimeShortFormat: "EEE dd-MMM-yyyy",
    dateTimeShort: "dd-MM-yyyy, h:mm a",
  },
  UK: {
    locale: "en-GB",
    shortDate: "dd-MM-yyyy",
    shortDateSlash: "dd/MM/yyyy",
    short: "dd-MM-yy",
    shortSlash: "dd/MM/yy",
    longDate: "dd MMMM yyyy",
    mediumDate: "dd MMM yy",
    longYearDate: "dd MMM yyyy",
    shorter: "dd/MM",
    medium: "dd MMM",
    fullDate: "dd-MM-yyyy h:mm a",
    dateTime: "EEE dd-MMM-yyyy, h:mm:ss a",
    dateTimeShortFormat: "EEE dd-MMM-yyyy",
    dateTimeShort: "dd-MM-yyyy, h:mm a",
  },
  Ireland: {
    locale: "en-GB",
    shortDate: "dd-MM-yyyy",
    shortDateSlash: "dd/MM/yyyy",
    short: "dd-MM-yy",
    shortSlash: "dd/MM/yy",
    longDate: "dd MMMM yyyy",
    mediumDate: "dd MMM yy",
    longYearDate: "dd MMM yyyy",
    shorter: "dd/MM",
    medium: "dd MMM",
    fullDate: "dd-MM-yyyy h:mm a",
    dateTime: "EEE dd-MMM-yyyy, h:mm:ss a",
    dateTimeShortFormat: "EEE dd-MMM-yyyy",
    dateTimeShort: "dd-MM-yyyy, h:mm a",
  },
};

export const EUROPEAN_LANGUAGES = {
  Deutsch: "de",
  // Italian: "it",
  // French: "fr",
  // Spanish: "es",
  // Greek: "el",
  // Turkish: "tr",
  // Portuguese: "pt",
  // Polish: "pl",
  // Dutch: "nl",
  English: "en",
};

export const TRANSLATE = {
  value: "ENABLE_TRANSLATION",
};
export const QUOTE_VALIDITY = 7;
export const PRIVACY_POLICY = "https://www.shopconnect.live/privacy-policy";
export const TERMS_AND_CONDITIONS =
  "https://www.shopconnect.live/terms-and-conditions";
